import { render, staticRenderFns } from "./social-club-create-post.vue?vue&type=template&id=36cd75fe&scoped=true&lang=pug"
import script from "./social-club-create-post.js?vue&type=script&lang=js&external"
export * from "./social-club-create-post.js?vue&type=script&lang=js&external"
import style0 from "./social-club-create-post.vue?vue&type=style&index=0&id=36cd75fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd75fe",
  null
  
)

export default component.exports